import { KoalaProxy } from "./loader";
export * from "./provider";
export default KoalaProxy.ko;
//# sourceMappingURL=index.js.map